import { FC, Dispatch, useEffect, useState } from "react";
import { StopEventPropagation } from "../../../helper/ui/methods";
import { UserInterface } from "../../../middleware/interfaces/user/user-interface";
import { UserDecisionInterface } from "../../../middleware/interfaces/user/user-decision-interface";
import { UserExternalConnectionInterface } from "../../../middleware/interfaces/user/user-external-connection-interface";
import {
  ExternalConnectionStatus,
  UserExternalConnectionStatusInterface,
} from "../../../middleware/interfaces/user/user-external-connection-status-interface";
import { UserExternalConnectionStatusRetrieve } from "../../../core/database/user/user-external-connection-status-retrieve";

interface userExternalConnectionDialogProps {
  reveal: boolean;
  user: UserInterface;
  setUserExternalConnectionDialogReveal: Dispatch<any>;
  dispatch: Dispatch<any>;
}

const UserExternalConnectionDialog: FC<userExternalConnectionDialogProps> = ({
  reveal,
  user,
  setUserExternalConnectionDialogReveal,
  dispatch,
}) => {
  const [close, setClose] = useState(false);
  const [autodeskConstructionCloud, setAutodeskConstructionCloud] =
    useState(false);
  const [trimbleConnect, setTrimbleConnect] = useState(false);
  const [connectionStatus, setConnectionStatus] =
    useState<UserExternalConnectionStatusInterface | null>(null);
  useEffect(() => {
    if (reveal && user.email) {
      setConnectionStatus(null);
      UserExternalConnectionStatusRetrieve.Retrieve(user.email).then(
        (serverResponse: any) => {
          if (
            serverResponse &&
            serverResponse.status === "success" &&
            serverResponse.data
          ) {
            setConnectionStatus(serverResponse.data);
          }
        },
      );
    }
  }, [reveal]);
  useEffect(() => {
    if (autodeskConstructionCloud) {
      const externalConnectionData: UserExternalConnectionInterface = {
        email: user.email,
        connectionDestination: "Autodesk Construction Cloud",
        type: "UserExternalConnectionInterface",
      };
      dispatch({
        type: "CREATE_EXTERNAL_CONNECTION",
        payload: externalConnectionData,
      });
      setAutodeskConstructionCloud(false);
      setUserExternalConnectionDialogReveal(false);
    }
  }, [autodeskConstructionCloud]);
  useEffect(() => {
    if (trimbleConnect) {
      const externalConnectionData: UserExternalConnectionInterface = {
        email: user.email,
        connectionDestination: "Trimble Connect",
        type: "UserExternalConnectionInterface",
      };
      dispatch({
        type: "CREATE_EXTERNAL_CONNECTION",
        payload: externalConnectionData,
      });
      setTrimbleConnect(false);
      setUserExternalConnectionDialogReveal(false);
    }
  }, [trimbleConnect]);
  useEffect(() => {
    if (close) {
      setClose(false);
      setUserExternalConnectionDialogReveal(false);
    }
  }, [close]);

  const ForgeButtonState = (status?: ExternalConnectionStatus) => {
    switch (status) {
      case "connected":
        return {
          value: "Forged ✓",
          className: "dialogForgeButton connected",
          title: "Connection active. Click to reconnect.",
        };
      case "expired":
        return {
          value: "Reforge",
          className: "dialogForgeButton expired",
          title: "Connection expired. Click to renew.",
        };
      default:
        return {
          value: "Forge",
          className: "dialogForgeButton",
          title: "Not connected yet. Click to connect.",
        };
    }
  };

  return (
    <>
      {(() => {
        if (reveal) {
          return (
            <div className="dialogCover" onClick={StopEventPropagation}>
              <div className="dialog">
                <div className="dialogHeader">
                  <div className="dialogHeading">
                    <h2 className="dialogTitle">External connections</h2>
                  </div>
                  <span className="dialogClose" onClick={() => setUserExternalConnectionDialogReveal(false)}>
                    ×
                  </span>
                </div>
                <div className="dialogBody">
                  <div className="dialogValueWrapper">
                    <span className="dialogInputLabel">Autodesk Construction Cloud</span>
                    <input
                      type="button"
                      name="autodeskConstructionCloud"
                      {...ForgeButtonState(
                        connectionStatus?.autodeskConstructionCloud,
                      )}
                      placeholder={"Autodesk Construction Cloud"}
                      onClick={() => {
                        setAutodeskConstructionCloud(true);
                      }}
                    />
                  </div>
                  <div className="dialogValueWrapper">
                    <span className="dialogInputLabel">Trimble Connect</span>
                    <input
                      type="button"
                      name="trimbleConnect"
                      {...ForgeButtonState(connectionStatus?.trimbleConnect)}
                      placeholder={"Trimble Connect"}
                      onClick={() => {
                        setTrimbleConnect(true);
                      }}
                    />
                  </div>

                </div>
                <div className="dialogButtonWrapper">
                  {/* dismissing is not an affirmative action, so this stays
                      the outlined secondary rather than the amber primary */}
                  <input
                    type="button"
                    name="close"
                    value="Close"
                    onClick={() => setClose(true)}
                  />
                </div>
              </div>
            </div>
          );
        } else {
          return <></>;
        }
      })()}
    </>
  );
};

export default UserExternalConnectionDialog;
